import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';


const KeywordSection = ({ onUpdate, fieldKey='text_enriched', boostInput = false }) => {
  const [currentKeywords, setCurrentKeywords] = useState('');
  const [boost, setBoost] = useState(1);

  const handleKeywordsAction = (actionType) => {
    if (!currentKeywords.trim()) return;
    
    const keywordsArray = currentKeywords.split(',').map(keyword => keyword.trim()).filter(keyword => keyword);
    if (keywordsArray.length === 0) return;
    
    const updateData = {
      action: actionType,
      filter: 'match',
      field: fieldKey,
      value: keywordsArray
    };
    
    // Add boost value if boostInput is enabled
    if (boostInput) {
      updateData.boost = boost;
    }
    
    onUpdate(updateData);
    setCurrentKeywords(''); // Reset after adding
  };

  return (
    <Box>
      <TextField
        label="Keywords"
        value={currentKeywords}
        onChange={(e) => setCurrentKeywords(e.target.value)}
        placeholder="Enter comma-separated keywords"
        helperText="e.g., blockchain, crypto, nft"
        fullWidth
        sx={{ mb: 2 }}
      />
      
      {boostInput && (
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="Boost"
          type="number"
          value={boost}
          onChange={(e) => setBoost(parseFloat(e.target.value) || 1)}
          inputProps={{ min: 0, step: 0.1 }}
        />
      )}
      
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleKeywordsAction('include')}
          disabled={!currentKeywords.trim()}
        >
          <AddIcon />
        </Button>
        
        {boostInput && (
          <Button
            variant="contained"
            color="success"
            onClick={() => handleKeywordsAction('boost')}
            disabled={!currentKeywords.trim()}
          >
            <TrendingUpIcon />
          </Button>
        )}
        
        <Button
          variant="contained"
          color="error"
          onClick={() => handleKeywordsAction('exclude')}
          disabled={!currentKeywords.trim()}
        >
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default KeywordSection;

